document.addEventListener("DOMContentLoaded", (event) => {
    const handleSellingPlans = (shadowRoot) => {
        const sellingPlansElement = shadowRoot.querySelector("rc-selling-plans");
        
        if (sellingPlansElement) {
            const sellingPlansShadowRoot = sellingPlansElement.shadowRoot;

            if (sellingPlansShadowRoot) {
                const buttons = sellingPlansShadowRoot.querySelectorAll("button, [role='button'], .rc-button, [class*='button']");
                
                let buttonToKeep = null;
                if (buttons.length > 0) {
                    buttonToKeep = buttons[0];
                    buttonToKeep.style.setProperty("cursor", "default", "important");
                    buttonToKeep.style.setProperty("pointer-events", "none", "important");
                    buttonToKeep.style.setProperty("width", "fit-content", "important");
                    buttonToKeep.style.setProperty("margin-left", "auto", "important");
                    buttonToKeep.style.setProperty("margin-right", "0", "important");
                }
                
                while (sellingPlansShadowRoot.firstChild) {
                    sellingPlansShadowRoot.removeChild(sellingPlansShadowRoot.firstChild);
                }
                
                if (buttonToKeep) {
                    sellingPlansShadowRoot.appendChild(buttonToKeep);
                }
            }
            
            sellingPlansElement.style.setProperty("pointer-events", "none", "important");
            sellingPlansElement.style.setProperty("width", "fit-content", "important");
            sellingPlansElement.style.setProperty("margin-left", "auto", "important");
            sellingPlansElement.style.setProperty("margin-right", "0", "important");
        } else {
            const sellingPlansByClass = shadowRoot.querySelector(".rc-selling-plans");
            if (sellingPlansByClass) {
                sellingPlansByClass.style.setProperty("pointer-events", "none", "important");
                sellingPlansByClass.style.setProperty("width", "fit-content", "important");
                sellingPlansByClass.style.setProperty("margin-left", "auto", "important");
                sellingPlansByClass.style.setProperty("margin-right", "0", "important");
            }
        }
    };

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "childList" && mutation.addedNodes.length > 0 && mutation.target.classList.contains("product-form")) {
                const widgetNode = document?.querySelector("recharge-subscription-widget");

                if (widgetNode) {
                    const shadowRoot = widgetNode.shadowRoot;

                    if (shadowRoot) {
                        const widgetRoot = shadowRoot.querySelector(".rc-selection__root");

                        if (widgetRoot) {
                            widgetRoot.style.setProperty("display", "flex");
                            widgetRoot.style.setProperty("flex-direction", "column-reverse");
                            widgetRoot.style.setProperty("gap", "10px");

                            handleSellingPlans(shadowRoot);

                            const partObserver = new MutationObserver((mutations) => {
                                mutations.forEach((mutation) => {
                                    if (mutation.type === "attributes" && mutation.attributeName === "part") {
                                        const target = mutation.target;
                                        const partValue = target.getAttribute("part");
                                        
                                        if (partValue && partValue.includes("rc-purchase-option__selected")) {
                                            handleSellingPlans(shadowRoot);
                                        }
                                    }
                                    
                                    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                                        mutation.addedNodes.forEach((node) => {
                                            if (node.nodeType === 1) { 
                                                const partValue = node.getAttribute?.("part");
                                                if (partValue && partValue.includes("rc-purchase-option__selected")) {
                                                    handleSellingPlans(shadowRoot);
                                                }
                                                
                                                const purchaseOptions = node.querySelectorAll?.(".rc-purchase-option, rc-purchase-option");
                                                if (purchaseOptions) {
                                                    purchaseOptions.forEach(option => {
                                                        const partValue = option.getAttribute("part");
                                                        if (partValue && partValue.includes("rc-purchase-option__selected")) {
                                                            handleSellingPlans(shadowRoot);
                                                        }
                                                    });
                                                }
                                            }
                                        });
                                    }
                                });
                            });

                            const purchaseOptions = shadowRoot.querySelectorAll(".rc-purchase-option, rc-purchase-option");
                            purchaseOptions.forEach(option => {
                                partObserver.observe(option, {
                                    attributes: true,
                                    attributeFilter: ["part"],
                                    childList: true,
                                    subtree: true
                                });
                            });

                            partObserver.observe(shadowRoot, {
                                childList: true,
                                subtree: true
                            });
                        }
                    } else {
                        console.warn("Cannot access shadow root (may be in 'closed' mode)");
                    }
                }
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    const checkWidget = () => {
        const widgetNode = document?.querySelector("recharge-subscription-widget");
        if (widgetNode?.shadowRoot) {
            const shadowRoot = widgetNode.shadowRoot;
            const widgetRoot = shadowRoot.querySelector(".rc-selection__root");
            if (widgetRoot) {
                widgetRoot.style.setProperty("display", "flex");
                widgetRoot.style.setProperty("flex-direction", "column-reverse");
                widgetRoot.style.setProperty("gap", "10px");
                
                handleSellingPlans(shadowRoot);

                const partObserver = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === "attributes" && mutation.attributeName === "part") {
                            const target = mutation.target;
                            const partValue = target.getAttribute("part");
                            
                            if (partValue && partValue.includes("rc-purchase-option__selected")) {
                                handleSellingPlans(shadowRoot);
                            }
                        }
                        
                        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                            mutation.addedNodes.forEach((node) => {
                                if (node.nodeType === 1) {
                                    const partValue = node.getAttribute?.("part");
                                    if (partValue && partValue.includes("rc-purchase-option__selected")) {
                                        handleSellingPlans(shadowRoot);
                                    }
                                    
                                    const purchaseOptions = node.querySelectorAll?.(".rc-purchase-option, rc-purchase-option");
                                    if (purchaseOptions) {
                                        purchaseOptions.forEach(option => {
                                            const partValue = option.getAttribute("part");
                                            if (partValue && partValue.includes("rc-purchase-option__selected")) {
                                                handleSellingPlans(shadowRoot);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    });
                });

                const purchaseOptions = shadowRoot.querySelectorAll(".rc-purchase-option, rc-purchase-option");
                purchaseOptions.forEach(option => {
                    partObserver.observe(option, {
                        attributes: true,
                        attributeFilter: ["part"],
                        childList: true,
                        subtree: true
                    });
                });

                partObserver.observe(shadowRoot, {
                    childList: true,
                    subtree: true
                });
            }
        }
    };

    setTimeout(checkWidget, 1000);
});